import {useEffect} from "react"
import { SlideCountdown } from 'react-fancy-countdown';
import { Line } from 'rc-progress';
const IcoCounter = () => {

  useEffect(() => {
    let PathProgs = document.querySelector('.rc-progress-line-trail')
    PathProgs.setAttribute('stroke' , "transparent")
  },[])

  return (
    <div className="ico-counter">
        <div className="counter-down">
            <div className="content">
                <div className="conuter-header">
                    <h3 className="text-center mb-30">TOKEN SALE ENDS IN</h3>
                </div>
                <div className="counterdown-content">
                    
                    <div className="count-down titled circled text-center">
                        <SlideCountdown
                          weeks={false}
                          deadline="2023-01-30 12:00:00" />
                    </div>
                    <div className="ico-progress">
                       <ul className="list-unstyled list-percent list-inline clearfix mb-10">
                          <li className="title">400 BNB</li>
                          <li className="strength">1600 BNB</li>
                       </ul>
                       <div className="current-progress">
                          <Line percent="0" trailWidth="3" strokeWidth="4" strokeColor="#4834d4" />
                       </div>
                       <span className="pull-left">Softcap</span>
                       <span className="pull-right">Token Hardcap</span>
                    </div>
                    <div className="text-center">
                        <a href="https://app.unicrypt.network/amm/babydoge-bsc-v1/ilo/0xe19d6edE61724c987f1b0C062c485E8a79b77ABf" className="button mt-30">Buy Tokens</a>
                    </div>
                </div>
                
            </div>
            
        </div>
    </div>
  );
}

export default IcoCounter;